import { createSlice } from "@reduxjs/toolkit";
import {
  getCandidateResultWithFilterPage,
  getCandidateResultWithId,
  getAllCandiateWithFilter,
} from "./thunk";

const initialState = {
  candidateResults: {
    data: [],
    count: 0,
  },
  singleCandidateResult: null,
  loading: false,
  error: null,
  filterParams: {
    currentPage: 1,
    perPage: 20,
  },
};

const candidateResultSlice = createSlice({
  name: "candidateResult",
  initialState,
  reducers: {
    setFilterParams: (state, action) => {
      state.filterParams = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all candidate results with filter (pagination)
      .addCase(getCandidateResultWithFilterPage.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCandidateResultWithFilterPage.fulfilled, (state, action) => {
        console.log("📦 Payload:", action.payload);
        state.loading = false;
        state.candidateResults = {
          data: action.payload?.data || [],
          count: action.payload?.count || 0,
        };
        state.error = null;
      })
      .addCase(getCandidateResultWithFilterPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch candidate results";
      })

      // Fetch a single candidate result by ID
      .addCase(getCandidateResultWithId.pending, (state) => {
        state.loading = true;
        state.singleCandidateResult = null;
      })
      .addCase(getCandidateResultWithId.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCandidateResult = action.payload;
        state.error = null;
      })
      .addCase(getCandidateResultWithId.rejected, (state, action) => {
        state.loading = false;
        state.singleCandidateResult = null;
        state.error = action.error.message || "Failed to fetch candidate result by ID";
      })

      // Fetch all candidate results (no filter or pagination)
      .addCase(getAllCandiateWithFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCandiateWithFilter.fulfilled, (state, action) => {
        console.log("📦 All Candidate Results Payload:", action.payload);
        state.loading = false;
        state.candidateResults = {
          data: action.payload || [],
          count: action.payload?.length || 0, // No count since we're fetching all data
        };
        state.error = null;
      })
      .addCase(getAllCandiateWithFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch all candidate results";
      });
  },
});

export const { setFilterParams } = candidateResultSlice.actions;
export default candidateResultSlice.reducer;
